/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function () {
  const siteNavigation = document.getElementById("site-navigation");

  // Return early if the navigation doesn't exist.
  if (!siteNavigation) {
    return;
  }

  const toggleButtons = document.querySelectorAll(".menu-toggle");

  // Toggle the .toggled class and the aria-expanded value each time a toggle button is clicked.
  toggleButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      siteNavigation.classList.toggle("toggled");

      toggleButtons.forEach(function (btn) {
        const isExpanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", isExpanded ? "false" : "true");
      });

      // Remove scrolling classes from body
      body.classList.remove("scroll-up", "scroll-down");
    });
  });

  // Get all the link elements within the menu.
  const menus = siteNavigation.querySelectorAll(".nav-container");

  // Loop through all menus
  menus.forEach(function (menu) {
    const links = menu.getElementsByTagName("a");

    // Toggle focus each time a menu link is focused or blurred.
    for (const link of links) {
      link.addEventListener("focus", toggleFocus, true);
      link.addEventListener("blur", toggleFocus, true);
    }

    // Toggle focus each time a menu link with children receive a touch event.
    const linksWithChildren = menu.querySelectorAll(
      ".menu-item-has-children > a, .page_item_has_children > a"
    );
    for (const link of linksWithChildren) {
      link.addEventListener("touchstart", toggleFocus, false);
    }
  });

  /**
   * Sets or removes .focus class on an element.
   */
  function toggleFocus(event) {
    if (event.type === "focus" || event.type === "blur") {
      let self = this;
      // Move up through the ancestors of the current link until we hit .nav-menu.
      while (!self.classList.contains("nav-container")) {
        // On li elements toggle the class .focus.
        if ("li" === self.tagName.toLowerCase()) {
          self.classList.toggle("focus");
        }
        self = self.parentNode;
      }
    }

    if (event.type === "touchstart") {
      const menuItem = this.parentNode;
      event.preventDefault();
      for (const link of menuItem.parentNode.children) {
        if (menuItem !== link) {
          link.classList.remove("focus");
        }
      }
      menuItem.classList.toggle("focus");
    }
  }

  // toggle button animation
  document.querySelectorAll(".toggle").forEach(function (toggleButton) {
    toggleButton.addEventListener("click", function () {
      this.classList.toggle("activate");
    });
  });

  // Old Code

  /**
   * Code for static menu
   */
  const body = document.body;
  let lastScroll = 0;

  // Throttle function
  const throttle = (func, limit) => {
    let inThrottle;
    return () => {
      if (!inThrottle && !siteNavigation.classList.contains("toggled")) {
        // Check if "toggled" class is not present
        func();
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  };

  // Update scroll function with optimized logic
  const updateScroll = () => {
    const currentScroll = window.scrollY;
    const isScrollingDown = currentScroll > lastScroll;

    // Check if scrolling to the top
    if (currentScroll <= 0) {
      body.classList.toggle("scroll-up", true);
      body.classList.toggle("scroll-down", false);
    } else {
      // Scrolling down or up
      body.classList.toggle("scroll-up", !isScrollingDown);
      body.classList.toggle("scroll-down", isScrollingDown);
    }

    lastScroll = currentScroll;
  };

  // Use throttled scroll event listener
  window.addEventListener("scroll", throttle(updateScroll, 100)); // Adjust the limit as needed
})();
